require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./redux-app-getting-to-start.json") })
        }
      }, "path---redux-app-getting-to-start");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---redux-app-getting-to-start!./.cache/json/redux-app-getting-to-start.json
// module id = 403
// module chunks = 231608221292675